import { Card, CardContent, Typography, styled, Box } from '@mui/material';
import { Tag } from '../../api/tagService';

const TagCardContainer = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[6],
  },
  background: 'linear-gradient(145deg, #1a0933 0%, #0f051d 100%)',
  border: '1px solid rgba(110, 59, 255, 0.3)',
}));

const TagName = styled(Typography)({
  background: 'linear-gradient(90deg, #6e3bff, #ff3bff)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 700,
  fontSize: '1.5rem',
});

export const TagCard = ({ tag }: { tag: Tag }) => {
  return (
    <TagCardContainer>
      <CardContent sx={{ flexGrow: 1 }}>
        <TagName variant="h5" gutterBottom>
          {tag.name}
        </TagName>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
          <Typography variant="body1" sx={{ color: '#b8b8b8' }}>
            Используется в {tag.video_count} видео
          </Typography>
        </Box>
      </CardContent>
    </TagCardContainer>
  );
};